import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "../common/Header";
import NavbarBoot from "../common/NavbarBoot";

/** Read cached user data synchronously so pages don't get empty userData on refresh */
function getInitialUserData() {
  try {
    const stored = sessionStorage.getItem("user");
    if (!stored) return "";
    const parsed = JSON.parse(stored);
    if (parsed?.isLoggedIn && parsed?.userData) return parsed.userData;
  } catch {
    // ignore corrupt cache
  }
  return "";
}

function RootLayout() {
  const [userData, setUserData] = useState(getInitialUserData);

  // ─── Shared Date Filter (synced across Dashboard ↔ Home) ───────────────────
  const MIN_DATE = "2024-07-01";
  const today = new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });

  // Default applied dates: 01.07.2024 → today (applied immediately on load)
  const [sharedStartDate, setSharedStartDate] = useState(MIN_DATE);
  const [sharedEndDate, setSharedEndDate]     = useState(today);

  return (
    <>
      <Header userData={userData} setUserData={setUserData} />
      <NavbarBoot userData={userData} setUserData={setUserData}/>
      <Outlet context={{
        userData,
        setUserData,
        sharedStartDate,
        setSharedStartDate,
        sharedEndDate,
        setSharedEndDate,
        MIN_DATE,
        today,
      }}/>
    </>
  );
}

export default RootLayout;


